import React from 'react'
import { times } from 'lodash-es'

import { TtSkeleton } from '@23/react'

import './FocusPreviewTrayQuestions.scss'

const FocusPreviewTrayQuestions = () => {
  return (
    <div className="focus-preview-tray-questions">
      {times(3, (idx) => (
        <div key={idx} className="focus-preview-tray-questions-item">
          <TtSkeleton />
          <TtSkeleton />
          <TtSkeleton />
        </div>
      ))}
    </div>
  )
}

export { FocusPreviewTrayQuestions }
